module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar3-fill-627f49a2.svg";